import throttle from '../utils/throttle';

export default class Header {
    constructor() {
        this.header = document.querySelector('.header');
        this.button = this.header.querySelector('.header__burger');
        this.button.addEventListener('click', this.toogleBurgerMenu.bind(this))

        window.addEventListener('scroll', throttle(() => {this.onScroll()}, 10))
        this.scrollY = false
    }

    toogleBurgerMenu(e) {
        e.preventDefault()
        this.header.classList.toggle('open')
    }

    onScroll() {
        const tolerence = 50
        if (this.scrollY <= tolerence && this.scrollY !== false) {
            this.header.classList.remove('scrolled')
        } else {
            this.header.classList.add('scrolled')
        }
        
        if (this.scrollY <= window.scrollY && this.scrollY !== false) {
            this.header.classList.remove('visible')
        } else {
            this.header.classList.add('visible')
        }

        this.scrollY = window.scrollY
    }

}
